<template>
  <!-- Contenedor Padre Fullscreen (Fijo a los bordes de la pantalla para evitar scroll de App.vue) -->
  <div v-if="!cargandoComponente && permitirVenta" class="fixed top-0 left-0 w-full h-screen m-0 p-2 zapi-bg flex flex-row overflow-hidden select-none z-5 gap-3">

    <!-- SECCIÓN IZQUIERDA: HEADER, CATÁLOGO Y CATEGORÍAS -->
    <div class="flex-1 flex flex-column h-full overflow-hidden py-3 pl-3 pr-0" style="min-width: 0;">

      <!-- ORGANISMO: BARRA SUPERIOR (HEADER) -->
      <ZapiHeader class="flex-shrink-0 z-5 mb-2" v-model:busqueda="busquedaProducto" :suggestions="productosFiltrados"
        :nombreSucursal="caja?.nombre_sucursal || 'Desconocida'"
        @buscarProducto="buscarProducto" @reportarMerma="abrirModalMerma" />

      <!-- MOLÉCULA: PESTAÑAS DE CATEGORÍAS -->
      <ZapiCategoryTabs v-model="categoriaActiva" :categorias="gruposNombres" />
      <div v-if="subgruposNombres.length > 0" class="subgrupo-wrapper">
        <p class="subgrupo-label">
          <i class="pi pi-level-down-right" style="font-size: 0.8rem"></i> Subcategoría de {{ categoriaActiva }}
        </p>
        <ZapiCategoryTabs is-sub v-model="subCategoriaActiva" :categorias="subgruposNombres" />
      </div>

      <!-- GRID DE PRODUCTOS CON SCROLL INTERNO CONTROLADO POR VH -->
      <div class="grid overflow-y-auto flex-1 align-content-start mt-0 mb-0 pt-3 pb-4 pos-grid-container"
        style="margin-left: -0.5rem; margin-right: -0.5rem;">
        <!-- Añadimos 'flex align-items-stretch' para que todas las columnas midan lo mismo de alto -->
        <div v-for="producto in productosPorCategoria" :key="producto.id"
          class="col-12 sm:col-6 md:col-4 lg:col-3 zapi-card-5 p-2 flex align-items-stretch zapi-card-wrapper">
          <!-- 'w-full' obliga a la tarjeta a rellenar todo el espacio de su celda perfectamente -->
          <ZapiProductCard 
          :producto="producto"
          :stockActual="producto.stock_actual"
          :stockMinimo="producto.stock_minimo"
          @seleccionar="seleccionarPizza" 
          class="w-full" />
        </div>
      </div>
    </div>

    <!-- SECCIÓN DERECHA: PANEL DE CONTROL DE FACTURACIÓN Y CARRITO -->
    <div class="flex-shrink-0 bg-white border-round shadow-1 p-4 flex flex-column overflow-hidden mt-3 mb-3 mr-3"
      style="width: clamp(28rem, 35vw, 45rem);">

        <!-- MOLÉCULA: FORMULARIO DEL CLIENTE -->
        <ZapiClientForm v-model:cliente="clienteSeleccionado" v-model:nit="nitCliente" :suggestions="clientesFiltrados"
          @buscarCliente="buscarCliente"
          @clienteSeleccionado="seleccionarCliente"
          @nuevoCliente="abrirModalCliente" />

      <!-- ORGANISMO: TABLA DEL CARRITO (SCROLL INDEPENDIENTE USANDO FLEX-1) -->
      <div class="mb-2 flex-1 overflow-y-auto pos-cart-table-container">
        <!-- TABLA DEL CARRITO: Pasamos eventos de eliminar y editar -->
        <ZapiCartTable 
          :carrito="carrito" 
          :salsasDisponibles="modalProductoSalsa"
          @editarCantidad="abrirNumpad" 
          @eliminar="eliminarDelCarrito"
          @editarSalsas="abrirEdicionSalsas" 
          @sumarCantidad="sumarCantidadCarrito" 
          @restarCantidad="restarCantidadCarrito" 
        />
      </div>

      <!-- PANEL DE TOTALES, ORIGEN Y MÉTODOS DE PAGO ANCLADO ABAJO -->
      <div class="mt-auto mb-1 border-top-1 surface-border pt-2 bg-gray-50 p-2 border-round flex-shrink-0">
        <!-- INDICADOR DE IMPRESORA LOCAL -->
        <div v-if="estadoImpresora !== 'conectado'" class="flex justify-content-between align-items-center mb-2 p-2 border-round surface-100 cursor-pointer border-1 border-red-500" @click="mostrarModalImpresora = true; buscarImpresoras();">
          <span class="text-red-500 font-bold text-sm"><i class="pi pi-exclamation-triangle mr-2"></i>Impresora Desconectada</span>
          <div class="flex align-items-center gap-2">
             <span v-if="estadoImpresora === 'verificando...'" class="text-orange-500 font-bold text-sm"><i class="pi pi-spin pi-spinner text-xs mr-1"></i>Buscando...</span>
             <span v-else class="text-red-500 font-bold text-sm text-underline">Conectar ahora</span>
          </div>
        </div>
        <div v-else class="flex justify-content-between align-items-center mb-2 p-2 border-round surface-100 cursor-pointer border-1 border-green-500" @click="mostrarModalImpresora = true; buscarImpresoras();">
          <span class="text-green-600 font-bold text-sm"><i class="pi pi-print mr-2"></i>Impresora Conectada</span>
          <span class="text-green-600 font-bold text-sm text-underline">Cambiar</span>
        </div>

        <!-- SUB TOTAL Y DESCUENTO -->
        <div class="flex justify-content-between mb-1 align-items-center">
          <span class="text-600 font-bold">Subtotal</span>
          <span class="font-medium text-900 text-lg">Bs. {{ totalCalculado }}</span>
        </div>

        <!-- PROMOCIONES DINÁMICAS -->
        <div v-if="descuentoTotalPromocional > 0" class="flex justify-content-between mb-1 align-items-center bg-yellow-50 p-2 border-round">
          <div class="flex flex-column">
            <span class="text-yellow-700 font-bold"><i class="pi pi-star-fill text-yellow-500 mr-1"></i> Descuento de Combo(s)</span>
            <small class="text-yellow-600" v-for="(p, i) in desglosePromociones" :key="i">
              {{ p.promocion }}
            </small>
          </div>
          <span class="font-bold text-red-500 text-lg">- Bs. {{ descuentoTotalPromocional }}</span>
        </div>
        
        <div class="flex justify-content-between mb-2 align-items-center" v-if="false">
          <span class="text-600 font-bold">Descuento (Bs.)</span>
          <div class="p-inputgroup" style="width: 120px;">
            <span class="p-inputgroup-addon p-1 text-sm font-bold">Bs.</span>
            <input type="number" class="p-inputtext p-component p-inputtext-sm text-right font-bold" v-model.number="descuentoManual" placeholder="0" min="0" />
          </div>
        </div>
        
        <div class="flex justify-content-between align-items-center mb-2 border-top-1 border-300 pt-2">
          <span class="text-xl font-bold text-900">Total a Pagar</span>
          <span class="text-3xl zapi-font zapi-text-red">Bs. {{ totalAPagar }}</span>
        </div>

        <!-- MOLÉCULA: SELECTOR DE ORIGEN -->
        <ZapiOriginSelector v-model="canalVenta" @metodos-disponibles="actualizarMetodosPago" :canalesPermitidos="canalesPermitidosCarrito" />

        <!-- MOLÉCULA: SELECTOR DE MÉTODOS DE PAGO EXPLÍCITOS -->
        <ZapiPaymentSelector v-model="metodoPago" :metodos="metodosDisponibles" />

        <!-- OBSERVACIÓN -->
        <div class="mt-3 mb-3">
          <input type="text" class="p-inputtext p-component w-full" v-model="observacionVenta" placeholder="Observación (opcional)" />
        </div>

        <!-- ACCIÓN PRINCIPAL DEL POS -->
        <Button label="Preparar" icon="pi pi-print"
          class="w-full p-button-lg zapi-bg-red zapi-font text-xl py-2 shadow-2 border-none border-round-xl" @click="prepararVenta"
          :loading="procesando"
          :disabled="carrito.length === 0 || procesando" />
      </div>

    </div>


    <!-- ORGANISMO MODAL: CONFIGURACIÓN DE LAS SALSAS Y EXTRAS DINÁMICOS -->
    <ZapiModalPizzaConfig 
      v-model:visible="mostrarModalPizza" 
      :pizza="pizzaEnEdicion"
      :salsasDisponibles="modalProductoSalsa"
      :catalogoPizzas="catalogoProductos"
      @confirmar="confirmarAgregarAlCarrito" 
      @cancelar="mostrarModalPizza = false" />

    <!-- ORGANISMO MODAL: TECLADO NUMÉRICO INTEGRADO DE CANTIDADES -->
    <ZapiModalNumpad v-model:visible="mostrarNumpad" :valorInicial="cantidadTemporal" @confirmar="confirmarNumpad"
      @cancelar="mostrarNumpad = false" />

    <!-- MODAL PARA CREAR UN NUEVO CLIENTE -->
    <ClienteCreate
      :show="mostrarModalCliente"
      :cliente="clienteParaModal"
      @closeModal="cerrarModalCliente"
      @actualizarListado="actualizarListadoClientes"
    />

    <!-- MODAL CONFIRMACIÓN DE VENTA -->
    <ZapiModalConfirmacionVenta
      v-model:visible="mostrarModalConfirmacion"
      :total="totalAPagar"
      :loading="procesando"
      :metodoPrincipalId="metodoPago"
      :nombreMetodoPrincipal="metodosDisponibles.find(m => m.value === metodoPago)?.label || 'Digital'"
      @confirm="procesarVenta"
    />

    <!-- MODAL SMART COMBO -->
    <ZapiModalSmartCombo
      v-model:visible="mostrarModalSmartCombo"
      :promoId="promoActivaId"
      :canalVentaId="canalVenta"
      :catalogoTotal="catalogoProductos"
      :grupos="rawGruposData"
      @confirmar="confirmarSmartCombo"
      @cancelar="mostrarModalSmartCombo = false; promoActivaId = null"
    />

    <!-- MODAL CONFIGURACIÓN IMPRESORA LOCAL -->
    <Dialog v-model:visible="mostrarModalImpresora" modal header="Configuración de Impresora Local" :style="{ width: '400px' }">
      <div class="flex flex-column gap-3 pt-2">
        <div class="text-center">
          <i class="pi pi-print text-4xl mb-2 text-primary"></i>
          <p class="m-0 text-secondary">Seleccione la impresora térmica que usará esta caja.</p>
        </div>
        <div class="flex flex-column gap-2">
          <label class="font-bold">Impresoras Detectadas:</label>
          <Dropdown v-model="impresoraSeleccionada" :options="listaImpresoras" optionLabel="name" placeholder="Seleccionar Impresora" class="w-full">
            <template #empty>
              No se detectaron impresoras USB o el servicio no está activo.
            </template>
          </Dropdown>
        </div>
      </div>
      <template #footer>
        <Button label="Test Impresión" icon="pi pi-print" class="p-button-secondary" @click="probarImpresionBackend" v-if="true" />
        <Button label="Cancelar" icon="pi pi-times" text @click="mostrarModalImpresora = false" />
        <Button label="Guardar" icon="pi pi-check" @click="guardarImpresora(impresoraSeleccionada)" :disabled="!impresoraSeleccionada" autofocus />
      </template>
    </Dialog>

    <Toast />
  </div>

  <!-- VISTA CUANDO LA CAJA ESTÁ CERRADA -->
  <div v-else-if="!cargandoComponente && !permitirVenta" class="p-4">
    <div class="grid">
      <Message class="col-12" :severity="'info'" :closable="false">
        <div class="flex align-items-center justify-content-center">
          <span> PARA REALIZAR VENTAS DEBE ABRIR LA CAJA </span>
          <Button
            label="APERTURAR CAJA"
            class="p-button-success p-button-lg ml-3"
            icon="pi pi-lock-open"
            v-tooltip.top="'Abrir Caja'"
            @click="this.$router.push({ name: 'caja' })"
          />
        </div>
      </Message>
    </div>
  </div>

  <!-- VISTA MIENTRAS VERIFICA LA CAJA -->
  <div v-else class="p-4">
    <div class="grid text-center">
      <h3 class="col-12 text-700">Verificando estado de la caja...</h3>
      <ProgressSpinner
        style="width: 50px; height: 50px"
        strokeWidth="8"
        fill="var(--surface-ground)"
        animationDuration=".5s"
        class="col-12"
      />
    </div>
  </div>
</template>

<script>

import { computed } from 'vue';
import { useStockPolling } from '@/composables/useStockPolling';
import { useImpresora } from '@/composables/useImpresora';
// IMPORTACIÓN DE LOS COMPONENTES DESDE TUS CARPETAS ATOMIC DESIGN
import PosService from '@/service/PosService';
import GrupoService from '@/service/GrupoService';
import CajaService from '@/service/CajaService';
import ClienteService from '@/service/ClienteService'; // NUEVO: Importación ClienteService
import VentaService from '@/service/VentaService';
import EmpresaService from '@/service/EmpresaService'; // NUEVO: Para cargar el logo global
import ZapiHeader from './ventas/view/VentaPOS/components/organisms/ZapiHeader.vue';
import ZapiCategoryTabs from './ventas/view/VentaPOS/components/molecules/ZapiCategoryTabs.vue';
import ZapiProductCard from './ventas/view/VentaPOS/components/molecules/ZapiProductCard.vue';
import ZapiClientForm from './ventas/view/VentaPOS/components/molecules/ZapiClientForm.vue';
import ZapiOriginSelector from './ventas/view/VentaPOS/components/molecules/ZapiOriginSelector.vue';
import ZapiPaymentSelector from './ventas/view/VentaPOS/components/molecules/ZapiPaymentSelector.vue';
import ZapiCartTable from './ventas/view/VentaPOS/components/organisms/ZapiCartTable.vue';
import ZapiModalPizzaConfig from './ventas/view/VentaPOS/components/organisms/ZapiModalPizzaConfig.vue';
import ZapiModalNumpad from './ventas/view/VentaPOS/components/organisms/ZapiModalNumpad.vue';
import ZapiModalConfirmacionVenta from './ventas/view/VentaPOS/components/organisms/ZapiModalConfirmacionVenta.vue';
import ZapiModalSmartCombo from './ventas/view/VentaPOS/components/organisms/ZapiModalSmartCombo.vue';
import ClienteCreate from '@/module/clientes/ClienteCreate.vue'; // MODAL PARA CREAR CLIENTES

export default {
  name: 'VentasPOS',
  components: {
    ZapiHeader,
    ZapiCategoryTabs,
    ZapiProductCard,
    ZapiClientForm,
    ZapiOriginSelector,
    ZapiPaymentSelector,
    ZapiCartTable,
    ZapiModalPizzaConfig,
    ZapiModalNumpad,
    ZapiModalConfirmacionVenta,
    ZapiModalSmartCombo,
    ClienteCreate
  },
  setup() {
    const { 
      estado: estadoImpresora, 
      listaImpresoras, 
      mostrarModal: mostrarModalImpresora,
      impresoraSeleccionada,
      verificarConexion: verificarConexionImpresora,
      buscarImpresoras,
      guardarImpresora,
      imprimir,
      imprimirTicketVentaBackend,
      probarImpresionBackend
    } = useImpresora();

    return {
      estadoImpresora,
      listaImpresoras,
      mostrarModalImpresora,
      impresoraSeleccionada,
      verificarConexionImpresora,
      buscarImpresoras,
      guardarImpresora,
      imprimir,
      imprimirTicketVentaBackend,
      probarImpresionBackend
    };
  },
  data() {
    return {
      // Estados globales de búsqueda y cliente
      busquedaProducto: null,
      productosFiltrados: [],
      clienteSeleccionado: null,
      clientesFiltrados: [],
      nitCliente: '',

      // Lógica de Canales y Métodos solicitados con v-model reactivo
      canalVenta: 1,
      metodosDisponibles: [],
      metodoPago: null,
      observacionVenta: '',
      descuentoManual: null,

      // Control del Carrito global
      carrito: [],

      // Control de Modales de flujo
      mostrarModalPizza: false,
      pizzaEnEdicion: null,
      
      // Control Smart Combo
      mostrarModalSmartCombo: false,
      promoActivaId: null,

      // NUEVO: Bandera para saber qué índice exacto del carrito se está editando
      // Si es null, significa que estamos agregando una pizza nueva. Si tiene un número, estamos editando.
      indiceEdicionSalsas: null,

      mostrarNumpad: false,
      indiceNumpad: null,
      cantidadTemporal: '1',

      mostrarModalConfirmacion: false,

      mostrarModalCliente: false,
      clienteParaModal: {},

      // Catálogo de Productos Completo
      categoriaActiva: 'Pizza',
      catalogoProductos: [],
      
      // Control de Grupos/Categorías
      gruposNombres: [],
      rawGruposData: [],
      subCategoriaActiva: null,
      cargandoGrupos: false,

      // Información de sesión / apertura
      caja: null,
      sucursal_id: null,
      empresaGlobal: null, // NUEVO: Almacena el logo y datos de la empresa principal
      logoImpresora: null, // NUEVO: Logo convertido a PNG para evitar errores en la impresora
      cargandoComponente: true,
      permitirVenta: false,

      // Prevención de doble clic
      procesando: false,
      stockEnTiempoReal:{},
      productosIds: [], //Para saber que productos fueron agregados

      // Promociones dinámicas
      evaluandoPromociones: false
    }
  },
  computed: {
    canalesPermitidosCarrito() {
      let permitidos = null;
      this.carrito.forEach(item => {
        if (item.es_smart_combo && item.canales_id && item.canales_id.length > 0) {
          if (permitidos === null) {
            permitidos = [...item.canales_id];
          } else {
            permitidos = permitidos.filter(id => item.canales_id.includes(id));
          }
        }
      });
      return permitidos;
    },
    // Calculamos el descuento en base a los combos armados
    descuentoTotalPromocional() {
      return this.carrito.reduce((sum, item) => sum + ((parseFloat(item.descuento_neto) || 0) * item.cantidad), 0);
    },
    desglosePromociones() {
      const desglose = [];
      this.carrito.forEach(item => {
        if (item.descuento_neto > 0 && item.nombre_paquete) {
          const existente = desglose.find(d => d.promocion === item.nombre_paquete);
          if (existente) {
            existente.monto += (item.descuento_neto * item.cantidad);
          } else {
            desglose.push({
              nombre_producto: item.nombre,
              promocion: item.nombre_paquete,
              monto: (item.descuento_neto * item.cantidad)
            });
          }
        }
      });
      return desglose;
    },
    // Cálculo reactivo centralizado de totales de la venta
    totalCalculado() {
      return this.carrito.reduce((sum, item) => sum + (item.precioBase * item.cantidad), 0);
    },
    // Total final con descuento manual aplicado y promos dinámicas
    totalAPagar() {
      return Math.max(0, this.totalCalculado - (parseFloat(this.descuentoManual) || 0) - this.descuentoTotalPromocional);
    },
    // Filtro reactivo para renderizar solo los productos de la categoría seleccionada
    /* productosPorCategoria() {
      return this.catalogoProductos.filter(prod => prod.tipoMenu === this.categoriaActiva && prod.tipoMenu !== 'NO DEFINIDO');
    }, */
    // NUEVO: Productos con stock actualizado para el grid
    subgruposNombres() {
      if (!this.categoriaActiva || !this.rawGruposData) return [];
      const grupoActivo = this.rawGruposData.find(g => g.gru_nombre === this.categoriaActiva);
      if (grupoActivo && grupoActivo.subgrupos && grupoActivo.subgrupos.length > 0) {
        return grupoActivo.subgrupos.map(s => s.sub_nombre);
      }
      return [];
    },
    productosPorCategoria() {
      // Si hay búsqueda, buscamos globalmente en el catálogo general
      if (this.busquedaProducto && this.busquedaProducto.trim() !== '') {
        const filtrados = this.catalogoProductos.filter(prod => {
          if (prod.tipoMenu === 'NO DEFINIDO') return false;
          return prod.nombre.toLowerCase().includes(this.busquedaProducto.toLowerCase());
        });

        // DESDUPLICACIÓN: Filtramos los productos para que no existan IDs duplicados
        // Esto evita que si el backend (getCatalogo) trae múltiples registros para un mismo
        // producto (ej. cruce de tablas o subgrupos), se muestren duplicados o triplicados.
        const unicosPorId = Array.from(new Map(filtrados.map(prod => [prod.id, prod])).values());

        return unicosPorId.map(prod => {
          const stockActual = this.obtenerStockProducto ? this.obtenerStockProducto(prod.id, prod.es_paquete) : null
          return {
            ...prod,
            stock_actual: stockActual !== null ? stockActual : prod.stock_actual,
            disponible: stockActual !== null ? stockActual > 0 : true
          }
        });
      }

      // Si no hay búsqueda, mostramos los productos del grupo o subgrupo activo desde el catalogo local
      const grupoActivo = this.rawGruposData.find(g => g.gru_nombre === this.categoriaActiva);
      if (!grupoActivo) return [];

      let productosBrutos = [];
      if (this.subgruposNombres.length > 0 && this.subCategoriaActiva) {
        const subActivo = grupoActivo.subgrupos.find(s => s.sub_nombre === this.subCategoriaActiva);
        if (subActivo) {
          // Filtrar del catalogoProductos: coincida grupo_id y subgrupo_id
          productosBrutos = this.catalogoProductos.filter(p => p.grupo_id === grupoActivo.gru_id && p.subgrupo_id === subActivo.sub_id);
        }
      } else {
        // Si el grupo tiene subgrupos (ej. Gaseosas -> 500ml), pero estamos en la pestaña principal, mostramos los que no tienen subgrupo (ej. sueltos).
        // Si el grupo NO tiene subgrupos (ej. Combos), mostramos todos los de ese grupo.
        if (grupoActivo.subgrupos && grupoActivo.subgrupos.length > 0) {
            productosBrutos = this.catalogoProductos.filter(p => p.grupo_id === grupoActivo.gru_id && (!p.subgrupo_id || p.subgrupo_id == 0));
        } else {
            productosBrutos = this.catalogoProductos.filter(p => p.grupo_id === grupoActivo.gru_id);
        }
      }

      return productosBrutos.map(p => {
        const stockActual = this.obtenerStockProducto ? this.obtenerStockProducto(p.id, p.es_paquete) : null;
        return {
          ...p, // Ya tiene el formato id, nombre, precioBase, ingredientes, etc.
          stock_actual: stockActual !== null ? stockActual : (p.stock_actual !== undefined ? p.stock_actual : 999),
          disponible: stockActual !== null ? stockActual > 0 : true
        }
      });
    },
    modalProductoSalsa() {
      return this.catalogoProductos.filter(prod => {
        const hasExtrasValue = prod.has_extras !== undefined ? prod.has_extras : prod.stock?.[0]?.has_extras;
        const hasExtras = ['1', 1, true, 'true'].includes(hasExtrasValue);
        const hasStock = Number(prod.stock_actual) > 0;

        return hasExtras && hasStock;
      });
    },

  },
  watch: {
    canalesPermitidosCarrito(newPermitidos) {
      if (newPermitidos && newPermitidos.length > 0) {
        if (!newPermitidos.includes(this.canalVenta)) {
          this.canalVenta = newPermitidos[0];
        }
      }
    },
    carrito: {
      handler() {
        this.evaluarPromocionesDinamicas();
      },
      deep: true
    },
    categoriaActiva() {
      // Limpiar la búsqueda global si el usuario hace clic en una pestaña de categoría
      this.busquedaProducto = null;

      if (this.subgruposNombres.length > 0) {
        this.subCategoriaActiva = this.subgruposNombres[0];
      } else {
        this.subCategoriaActiva = null;
      }
    },
    subCategoriaActiva() {
      // Limpiar la búsqueda global si el usuario hace clic en una pestaña de subcategoría
      this.busquedaProducto = null;
    },
    canalVenta() {
      this.recalcularPreciosCarrito();
      this.evaluarPromocionesDinamicas();
    }
  },
  created() {
    this.posService = new PosService();
    this.grupoService = new GrupoService();
    this.cajaService = new CajaService();
    this.clienteService = new ClienteService();
    this.ventaService = new VentaService();
    this.empresaService = new EmpresaService();
    
    // Cargar la empresa global para tener el logo listo para imprimir
    this.empresaService.getFirstEmpresa().then(async (response) => {
      this.empresaGlobal = response.data;
      if (this.empresaGlobal && this.empresaGlobal.logo) {
         this.logoImpresora = await this.convertirLogoAPng(this.empresaGlobal.logo);
      }
    }).catch(e => console.error("Error cargando logo para impresora:", e));
  },
  mounted() {
    this.verificarCajaAbierta();
    this.cargarGrupos();
    this.cargarCatalogo();
    this.iniciarPollingStock();
    this.verificarConexionImpresora(true);
  },
  methods: {
    getImageUrl(img) {
      if (!img) return null;
      if (img.startsWith("http")) return img;
      if (/\.(jpeg|jpg|gif|png|webp|svg)$/i.test(img)) {
        return process.env.VUE_APP_ROOT_API.replace(/\/api$/, "") + "/storage/" + img;
      }
      return "data:image/png;base64, " + img;
    },
    async convertirLogoAPng(base64Original) {
      return new Promise((resolve) => {
        if (!base64Original) { resolve(null); return; }
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX_WIDTH = 300;
          let width = img.width;
          let height = img.height;
          
          if (width > MAX_WIDTH) {
            height = Math.round((height * MAX_WIDTH) / width);
            width = MAX_WIDTH;
          }
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);
          
          const dataUrl = canvas.toDataURL('image/png');
          const base64Png = dataUrl.replace(/^data:image\/png;base64,/, "");
          resolve(base64Png);
        };
        img.onerror = () => {
          console.error("Error al convertir el logo a PNG");
          resolve(base64Original);
        };
        const src = base64Original.startsWith('data:') ? base64Original : 'data:image/jpeg;base64,' + base64Original;
        img.src = src;
      });
    },
    verificarCajaAbierta() {
      this.cargandoComponente = true;
      this.cajaService.verificarCajaAbierta().then((response) => {
        if (response.caja && response.caja.length > 0) {
          this.caja = response.caja[0];
          this.sucursal_id = response.caja[0].sucursal_id;
          this.permitirVenta = true;
        } else {
          this.permitirVenta = false;
          this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'No tienes una caja abierta. Debes abrir caja para facturar.', life: 5000 });
        }
      }).catch(err => {
        console.error("Error al verificar caja:", err);
        this.permitirVenta = false;
      }).finally(() => {
        this.cargandoComponente = false;
      });
    },
    evaluarPromocionesDinamicas() {
      // DESACTIVADO POR PETICIÓN DEL CLIENTE: 
      // Las promociones ya no se evalúan automáticamente enviando al backend.
      // Ahora se calculan directamente en las propiedades computadas `descuentoTotalPromocional`
      // basadas en lo que el usuario haya seleccionado explícitamente en el modal de Smart Combos.
      return;
    },
    cargarGrupos() {
      this.cargandoGrupos = true;
      this.grupoService.getMenuFrontend().then((response) => {
        // Soporte por si la respuesta viene con una propiedad grupos, data, o si es directamente el array
        const rawGrupos = response.grupos ? response.grupos : (response.data ? response.data : response);
        this.rawGruposData = Array.isArray(rawGrupos) ? rawGrupos : [];
        
        // Filtrar grupos activos (estado != 0) y omitir "NO DEFINIDO"
        this.gruposNombres = this.rawGruposData.filter(g => g.estado != 0 && g.gru_nombre !== 'NO DEFINIDO').map(g => g.gru_nombre);
        this.cargandoGrupos = false;

        // Seleccionar el primero por defecto
        if (this.gruposNombres.length > 0 && !this.gruposNombres.includes(this.categoriaActiva)) {
          this.categoriaActiva = this.gruposNombres[0];
        }
      }).catch(err => {
        console.error("Error cargando grupos:", err);
        this.cargandoGrupos = false;
      });
    },
    async cargarCatalogo() {
      try {
        const response = await this.posService.getCatalogo();
        const rawData = response.data.data ? response.data.data : response.data;
        if (rawData) {
          this.catalogoProductos = rawData.map(prod => ({
            ...prod,
            nombre: prod.descripcion || prod.nombre,
            ingredientes: prod.caso_uso || prod.ingredientes,
            es_paquete: prod.es_paquete || false,
            precioBase: parseFloat(prod.precio_venta || prod.precioBase || 0),
            tipoMenu: prod.grupo_nombre || prod.tipoMenu,
            imagen: this.getImageUrl(prod.imagen)
          }));
        }
      } catch (error) {
        console.error("Error cargando el catálogo:", error);
      }
    },
    buscarProducto(event) {
      const resultados = this.catalogoProductos.filter(p => p.nombre.toLowerCase().includes(event.query.toLowerCase()));
      // DESDUPLICACIÓN: Evita sugerencias repetidas en el buscador de la cabecera
      this.productosFiltrados = Array.from(new Map(resultados.map(prod => [prod.id, prod])).values());
    },
    buscarCliente(event) {
      if (!this.clienteService) return;
      this.clienteService.buscarXNombre({ texto: event.query, sucursal_id: this.sucursal_id })
        .then((response) => {
          if (response && response.clientes) {
            this.clientesFiltrados = response.clientes;
          } else {
            this.clientesFiltrados = [];
          }
        })
        .catch(err => console.error("Error buscando cliente:", err));
    },
    /* recalcularPreciosCarrito() {
       Forzar que Vue recalcule las propiedades computadas que dependan del carrito
      this.carrito = [...this.carrito]; 
    }, */

    // CONFIRMACIÓN DEL ZapiModalSmartCombo
    confirmarSmartCombo({ selecciones, promo }) {
      this.mostrarModalSmartCombo = false;
      this.promoActivaId = null;
      
      // 1. Crear un identificador único para agrupar los items de este combo
      const comboGroupId = 'smartcombo_' + Date.now();

      // 2. Agregar el "paquete abstracto" al carrito para que el usuario sepa que es una promo,
      // pero con precio 0. Sus items hijos tendrán los precios que luego el motor descontará.
      this.carrito.push({
        id: promo.id,
        nombre: `Combo: ${promo.nombre}`,
        es_smart_combo: true,
        combo_group_id: comboGroupId,
        canales_id: promo.canales_id,
        precioBase: 0,
        cantidad: 1,
        stock_actual: 999
      });

      // 3. Agregar los productos seleccionados al carrito, vinculados a ese combo
      selecciones.forEach(prod => {
        // Buscamos si necesita configuración (Ej. pizza con bordes o extra)
        // En una v2 se podría abrir el modal de configuración en cadena, 
        // pero por ahora lo agregamos directo.
        this.carrito.push({
          ...prod,
          cantidad: 1,
          combo_group_id: comboGroupId, // Referencia al combo padre
          // Ocultamos la eliminación individual para que si borran un ítem, deban borrar todo el combo? 
          // (opcional, por ahora lo agregamos normal)
        });
      });

      this.recalcularPreciosCarrito();
      this.$toast.add({ severity: 'success', summary: 'Combo Armado', detail: 'Los productos se agregaron al carrito.', life: 3000 });
    },

    abrirModalImpresora() {
      this.cargarImpresoras();
      this.mostrarModalImpresora = true;
    },

    seleccionarCliente(cliente) {      
      this.clienteSeleccionado = cliente;
      this.nitCliente = cliente.ci_nit || '0';
    },
    abrirModalCliente() {
      this.mostrarModalCliente = true;
      let nombrePrellenado = '';
      if (this.clienteSeleccionado) {
        nombrePrellenado = this.clienteSeleccionado.nombre || (typeof this.clienteSeleccionado === 'string' ? this.clienteSeleccionado : '');
      }
      this.clienteParaModal = {
        estado: { label: "Activo", value: 1 },
        nombre: nombrePrellenado,
        tipo_cliente: 0
      };
    },
    cerrarModalCliente() {
      this.mostrarModalCliente = false;
      this.clienteParaModal = {};
    },
    actualizarListadoClientes(nuevoCliente) {
      this.seleccionarCliente(nuevoCliente);
      this.cerrarModalCliente();
    },
    // MODIFICADO: Agregar al carrito con validación de stock
    seleccionarPizza(pizza) {
      // 1. Interceptar si es un Smart Combo
      if (pizza.es_smart_combo) {
        this.promoActivaId = pizza.id; // El 'id' de la promoción que el backend inyectó
        this.mostrarModalSmartCombo = true;
        return;
      }

      // Verificar stock antes de agregar
      let stockActual = this.obtenerStockProducto(pizza.id, pizza.es_paquete);
      if (stockActual === null) {
        stockActual = pizza.stock_actual;
      }

      // Si tiene stock, proceder
      if (pizza.requiere_modal === true) {
        // Inicializamos el objeto base de la pizza
        const nuevaPizza = {
          ...pizza,
          cantidad: 1,
          stock_actual: stockActual // Guardar stock en el objeto
        };
        
        // Inyectamos a 1 todas las salsas dinámicas encontradas por el filtro
        this.modalProductoSalsa.forEach(salsa => {
          nuevaPizza['salsa_' + salsa.id] = 1;
        });

        this.pizzaEnEdicion = nuevaPizza;
        this.mostrarModalPizza = true;
      } else {
        const existente = this.carrito.find(item => item.id === pizza.id && item.es_paquete === pizza.es_paquete);
        if (existente) {
          existente.cantidad += 1;
        } else {
          this.carrito.push({ ...pizza, cantidad: 1, stock_actual: stockActual });
        }
      }
      this.recalcularPreciosCarrito();
    },
    // EVENTO DESDE ZapiCartTable: Se ejecuta al tocar el lápiz en la tabla
    abrirEdicionSalsas(index) {
      this.indiceEdicionSalsas = index;

      // Clonamos el objeto de la fila usando Destructuring (...). 
      // Esto previene que si el cajero cambia algo y luego le da a "Cancelar", el carrito original se haya modificado.
      this.pizzaEnEdicion = { ...this.carrito[index] };
      this.mostrarModalPizza = true;
    },

    // CONFIRMACIÓN DEL MODAL ZapiModalPizzaConfig
    confirmarAgregarAlCarrito(pizzaConfigurada) {
      // Guardamos valores originales para que la edición repetida no corrompa los datos
      if (pizzaConfigurada._precioOriginal === undefined) {
         pizzaConfigurada._precioOriginal = pizzaConfigurada.precioBase;
      }
      if (!pizzaConfigurada._nombreOriginal) {
         pizzaConfigurada._nombreOriginal = pizzaConfigurada.nombre;
      }
      
      pizzaConfigurada.nombre = pizzaConfigurada._nombreOriginal;

      if (pizzaConfigurada.es_mixta) {
        pizzaConfigurada.nombre = `Mixta de ${pizzaConfigurada._nombreOriginal} y ${pizzaConfigurada.pizza_mitad_2.nombre}`;
        pizzaConfigurada.nombre_paquete = pizzaConfigurada.nombre; // Para el comprobante backend
      }

      // Verificar stock antes de confirmar
      let stockActual = this.obtenerStockProducto(pizzaConfigurada.id, pizzaConfigurada.es_paquete)
      if (stockActual === null) {
        stockActual = pizzaConfigurada.stock_actual;
      }
      
      if (this.indiceEdicionSalsas !== null) {
        // --- MODO EDICIÓN ---
        // Reemplazamos la fila exacta del carrito con el nuevo objeto editado
        this.carrito[this.indiceEdicionSalsas] = { ...pizzaConfigurada };
        this.$toast.add({ severity: 'success', summary: 'Actualizado', detail: 'Configuración modificada.', life: 2000 });

        // 🧹 Limpiamos la bandera de edición para futuras interacciones
        this.indiceEdicionSalsas = null;
      } else {
        // --- MODO AGREGAR NUEVO ---
        // Lógica de colisión: Verificamos si la pizza tiene exactamente las mismas salsas que otra que ya está en el carrito
        const existente = this.carrito.find(item => {
          if (item.id !== pizzaConfigurada.id) return false;
          if (item.es_paquete !== pizzaConfigurada.es_paquete) return false;
          
          // Verificamos si coinciden en ser mixtas y su segunda mitad
          if (Boolean(item.es_mixta) !== Boolean(pizzaConfigurada.es_mixta)) return false;
          if (item.es_mixta && item.pizza_mitad_2?.id !== pizzaConfigurada.pizza_mitad_2?.id) return false;

          // Verificamos los bordes seleccionados
          const bordesItem = item.bordes_seleccionados || [];
          const bordesConfig = pizzaConfigurada.bordes_seleccionados || [];
          if (bordesItem.length !== bordesConfig.length) return false;
          
          const bordesItemIds = bordesItem.map(b => b.id).sort().join(',');
          const bordesConfigIds = bordesConfig.map(b => b.id).sort().join(',');
          if (bordesItemIds !== bordesConfigIds) return false;

          // Verificamos los extras seleccionados
          const extrasItem = item.extras_seleccionados || [];
          const extrasConfig = pizzaConfigurada.extras_seleccionados || [];
          if (extrasItem.length !== extrasConfig.length) return false;
          
          const extrasItemIds = extrasItem.map(e => e.id).sort().join(',');
          const extrasConfigIds = extrasConfig.map(e => e.id).sort().join(',');
          if (extrasItemIds !== extrasConfigIds) return false;

          // Verificamos dinámicamente si todas las salsas coinciden
          let coincidenSalsas = true;
          this.modalProductoSalsa.forEach(salsa => {
            const key = 'salsa_' + salsa.id;
            if ((item[key] || 0) !== (pizzaConfigurada[key] || 0)) {
              coincidenSalsas = false;
            }
          });
          
          return coincidenSalsas;
        });


        if (existente) {
          // Si colisiona, simplemente agrupamos sumando las cantidades
          existente.cantidad += pizzaConfigurada.cantidad;
        } else {
          // Si es una combinación única, la empujamos como nueva fila al carrito
          this.carrito.push({ ...pizzaConfigurada });
        }
        this.$toast.add({ severity: 'success', summary: 'Agregado', detail: `${pizzaConfigurada.nombre} al pedido.`, life: 2000 });
      }

      this.recalcularPreciosCarrito();

      // Cerramos el modal de pizzas y limpiamos la variable temporal
      this.mostrarModalPizza = false;
      this.pizzaEnEdicion = null;
    },
    eliminarDelCarrito(index, combo_group_id) {
      if (combo_group_id) {
        // Eliminar todos los ítems asociados a este combo
        this.carrito = this.carrito.filter(item => item.combo_group_id !== combo_group_id);
      } else {
        this.carrito.splice(index, 1);
      }
      this.recalcularPreciosCarrito();
    },
    sumarCantidadCarrito(index) {
      this.carrito[index].cantidad++;
    },
    restarCantidadCarrito(index) {
      if (this.carrito[index].cantidad > 1) {
        this.carrito[index].cantidad--;
      } else {
        // Si baja de 1, eliminamos del carrito para mantenerlo limpio
        this.eliminarDelCarrito(index);
      }
    },
    abrirNumpad(index) {
      this.indiceNumpad = index;
      this.cantidadTemporal = String(this.carrito[index].cantidad);
      this.mostrarNumpad = true;
    },
    confirmarNumpad(cantidadEmitida) {
      const nuevaCantidad = parseInt(cantidadEmitida, 10);
      if (nuevaCantidad > 0) {
        this.carrito[this.indiceNumpad].cantidad = nuevaCantidad;
        this.mostrarNumpad = false;
        this.$toast.add({ severity: 'success', summary: 'Actualizado', detail: 'Cantidad modificada.', life: 2000 });
      } else {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'La cantidad debe ser mayor a 0.', life: 2000 });
      }
    },
    abrirModalMerma() {
      this.$toast.add({ severity: 'info', summary: 'Módulo Merma', detail: 'Abriendo registro rápido de control de mermas e insumos...', life: 3000 });
    },
    
    actualizarMetodosPago(metodosDb) {
      if (!metodosDb) return;
      
      // Los únicos 3 métodos que queremos mostrar en la interfaz
      const metodosFijos = [
        { label: 'Efectivo', value: 1, icon: 'pi pi-money-bill' },
        { label: 'Tarjeta', value: 2, icon: 'pi pi-credit-card' },
        { label: 'Pago QR', value: 6, icon: 'pi pi-qrcode' },
        { label: 'Pago Online', value: 4, icon: 'pi pi-desktop' }
      ];

      // Filtramos para mostrar SOLO los botones que están permitidos por el backend
      // AHORA: Mostramos siempre los 3, pero bloqueamos (disabled) los que no están permitidos
      this.metodosDisponibles = metodosFijos.map(fijo => ({
        ...fijo,
        disabled: !metodosDb.some(db => db.id === fijo.value)
      }));

      // Obtenemos cuántos de los botones "visuales" (los fijos) quedaron habilitados
      const habilitadosVisibles = this.metodosDisponibles.filter(m => !m.disabled);

      // Si el canal de venta SOLO tiene 1 método en base de datos (Ej: PedidosYa -> Transferencia id:4)
      // Asignamos el ID interno para que el backend lo registre correctamente.
      if (metodosDb.length === 1) {
        this.metodoPago = metodosDb[0].id;
      } 
      // Si hay botones visibles habilitados, seleccionamos el primero de ellos por defecto
      else if (habilitadosVisibles.length > 0) {
        const existe = habilitadosVisibles.find(m => m.value === this.metodoPago);
        if (!existe) {
          this.metodoPago = habilitadosVisibles[0].value;
        }
      } else {
        this.metodoPago = null;
      }
    },

    /**
     * Recalcula dinámicamente los precios de todos los productos en el carrito de compras.
     * Este método garantiza que cada ítem refleje el precio correcto basado en el 
     * canal de venta seleccionado actualmente en el POS, siguiendo el mapeo estricto del negocio:
     * 
     * - Canal 1 (Local) / Canal 5 (WhatsApp): Utilizan el `precio_venta` o `precioBase` normal.
     * - Canal 2 (PedidosYa): Utiliza la tarifa preferencial `pv3` de la base de datos.
     * - Canal 3 (Yango): Utiliza la tarifa preferencial `pv2` de la base de datos.
     * - Canal 4 (Turbo): Utiliza la tarifa preferencial `pv4` de la base de datos.
     * 
     * @observación Si el producto no tiene una tarifa especial configurada para un canal 
     * externo (ej. la base de datos devuelve "0.00"), el sistema actúa con un "fallback" seguro 
     * manteniendo el `precioBase` original para evitar cobrar 0 Bs por un producto.
     * 
     * @returns {void} Muta directamente el estado reactivo de `this.carrito`, actualizando la propiedad `precioFinal` de cada ítem.
     */
    recalcularPreciosCarrito() {
      this.carrito.forEach(item => {
        // Asegurar que guardamos el precio original del catálogo la primera vez
        if (item._precioOriginal === undefined) {
          item._precioOriginal = item.precioBase;
        }

        let precioFinal = parseFloat(item._precioOriginal || 0);

        /**
         * MULTIPLICADOR DE COMBOS:
         * Si el ítem es un combo (paquete), extraemos `cantidad_personalizable` que viene desde la BD.
         * Este valor (ej: 2) nos dice exactamente cuántas pizzas/hamburguesas reales hay adentro.
         * Ignora productos estáticos como sodas. Si no es paquete, el multiplicador es 1.
         * @type {number}
         */
        let multiplicador = item.es_paquete ? (item.cantidad_personalizable || 1) : 1;

        // Aplicar regla de precios por canal de venta, si es 0 mantener el precio base
        if (this.canalVenta === 3) {
          let p = parseFloat(item.pv2);
          if (p > 0) precioFinal = p;
        }
        else if (this.canalVenta === 2) {
          let p = parseFloat(item.pv3);
          if (p > 0) precioFinal = p;
        }
        else if (this.canalVenta === 4) {
          let p = parseFloat(item.pv4);
          if (p > 0) precioFinal = p;
        }

        // Si es pizza mixta, promediamos con la segunda mitad
        if (item.es_mixta && item.pizza_mitad_2) {
          let precioMitad2 = parseFloat(item.pizza_mitad_2._precioOriginal || item.pizza_mitad_2.precioBase || item.pizza_mitad_2.precio_venta || 0);
          
          if (this.canalVenta === 3) precioMitad2 = parseFloat(item.pizza_mitad_2.pv2 || precioMitad2);
          else if (this.canalVenta === 2) precioMitad2 = parseFloat(item.pizza_mitad_2.pv3 || precioMitad2);
          else if (this.canalVenta === 4) precioMitad2 = parseFloat(item.pizza_mitad_2.pv4 || precioMitad2);

          precioFinal = (precioFinal + precioMitad2) / 2;
        }

        item._precioCanal = precioFinal; // Guardar el precio base limpio sin sumarle los extras

        // Sumar complementos como bordes
        if (item.bordes_seleccionados && item.bordes_seleccionados.length > 0) {
          item.bordes_seleccionados.forEach(b => {
             let precioBorde = parseFloat(b.precio_venta || 0);
             if (this.canalVenta === 3) precioBorde = parseFloat(b.pv2 || precioBorde);
             else if (this.canalVenta === 2) precioBorde = parseFloat(b.pv3 || precioBorde);
             else if (this.canalVenta === 4) precioBorde = parseFloat(b.pv4 || precioBorde);
             
             precioFinal += (precioBorde * multiplicador);
          });
        }

        // Sumar complementos como extras
        if (item.extras_seleccionados && item.extras_seleccionados.length > 0) {
          item.extras_seleccionados.forEach(e => {
             let precioExtra = parseFloat(e.precio_venta || 0);
             if (this.canalVenta === 3) precioExtra = parseFloat(e.pv2 || precioExtra);
             else if (this.canalVenta === 2) precioExtra = parseFloat(e.pv3 || precioExtra);
             else if (this.canalVenta === 4) precioExtra = parseFloat(e.pv4 || precioExtra);
             
             precioFinal += (precioExtra * multiplicador);
          });
        }

        item.precioBase = precioFinal;
      });
    },

    prepararVenta() {
      this.mostrarModalConfirmacion = true;
    },
    async procesarVenta(montosConfirmados) {
      if (this.procesando) return;
      this.procesando = true;
      try {
        const userStr = localStorage.getItem('user');
        const user = userStr ? JSON.parse(userStr) : null;
        const sucursalActiva = this.sucursal_id || (user ? user.sucursal_id : 1);

        // 1. Mapeo de Productos para el backend (Estructura minimalista para PosController)
        const productosPayload = [];
        const paquetesPayload = [];
        
        this.carrito.forEach(item => {
          if (item.es_smart_combo) return;

          // Extraemos los complementos (ej. Salsas) que tenga este item
          const complementosItem = [];

          /**
           * MULTIPLICADOR PARA ENVÍO A BD:
           * Este multiplicador define con cuánta "cantidad" se va a enviar el extra a la cocina y BD.
           * Ej: Borde de Queso, cantidad = 2 (Si el combo tenía 2 pizzas personalizables).
           */
          let multiplicador = item.es_paquete ? (item.cantidad_personalizable || 1) : 1;

          // Agregamos los bordes primero para que aparezcan justo debajo del producto
          if (item.bordes_seleccionados && item.bordes_seleccionados.length > 0) {
            item.bordes_seleccionados.forEach(b => {
              let precioBorde = parseFloat(b.precio_venta || 0);
              if (this.canalVenta === 3) precioBorde = parseFloat(b.pv2 || precioBorde);
              else if (this.canalVenta === 2) precioBorde = parseFloat(b.pv3 || precioBorde);
              else if (this.canalVenta === 4) precioBorde = parseFloat(b.pv4 || precioBorde);

              complementosItem.push({
                producto_id: b.id,
                cantidad: item.es_paquete ? multiplicador : item.cantidad,
                precio: precioBorde
              });
            });
          }

          // Agregamos los extras
          if (item.extras_seleccionados && item.extras_seleccionados.length > 0) {
            item.extras_seleccionados.forEach(e => {
              let precioExtra = parseFloat(e.precio_venta || 0);
              if (this.canalVenta === 3) precioExtra = parseFloat(e.pv2 || precioExtra);
              else if (this.canalVenta === 2) precioExtra = parseFloat(e.pv3 || precioExtra);
              else if (this.canalVenta === 4) precioExtra = parseFloat(e.pv4 || precioExtra);
              
              complementosItem.push({
                producto_id: e.id,
                cantidad: item.es_paquete ? multiplicador : item.cantidad,
                precio: precioExtra
              });
            });
          }

          this.modalProductoSalsa.forEach(salsa => {
            const cantSalsa = item['salsa_' + salsa.id] || 0;
            if (cantSalsa > 0) {
              complementosItem.push({
                producto_id: salsa.id,
                // OJO: El backend multiplica los complementos de paquetes por la cantidad del paquete,
                // pero NO multiplica los de productos sueltos. Ajustamos aquí para enviar lo correcto:
                cantidad: item.es_paquete ? (cantSalsa * multiplicador) : (cantSalsa * item.cantidad)
              });
            }
          });

          if (item.es_mixta && item.pizza_mitad_2) {
            complementosItem.push({
              producto_id: item.pizza_mitad_2.id,
              cantidad: item.cantidad
            });
          }

          if (item.es_paquete) {
            paquetesPayload.push({
              paquete_id: item.id,
              cantidad: item.cantidad,
              precio_unitario: item._precioCanal !== undefined ? item._precioCanal : parseFloat(item.precioBase),
              complementos: complementosItem
            });
          } else {
            productosPayload.push({
              producto_id: item.id,
              cantidad: item.cantidad,
              precio: item._precioCanal !== undefined ? item._precioCanal : parseFloat(item.precioBase),
              descuento_neto: parseFloat(item.descuento_neto) || 0,
              lote: "0",
              fecha_vence: null,
              complementos: complementosItem,
              nombre_paquete: item.nombre_paquete || null,
              es_mixta: item.es_mixta || false,
              es_paquete: item.es_paquete || false
            });
          }
        });

        // Ahora this.metodoPago ya contiene el ID real de la base de datos (Ej: 1, 2, 4, 6)
        const pagoId = this.metodoPago || 1;

        let efectivoVenta = 0;
        let montoPagoVenta = 0;

        if (montosConfirmados) {
          efectivoVenta = montosConfirmados.efectivo || 0;
          montoPagoVenta = montosConfirmados.monto_pago || 0;
        } else {
          // Fallback por si acaso
          if (pagoId === 1) {
            efectivoVenta = this.totalAPagar;
            montoPagoVenta = 0;
          } else {
            efectivoVenta = 0;
            montoPagoVenta = this.totalAPagar;
          }
        }

        // 2. Construcción del Payload (Estructura idéntica a VentasCrear.vue)
        const payload = {
          cliente_id: this.clienteSeleccionado ? (this.clienteSeleccionado.id || this.clienteSeleccionado.cliente_id) : 1, // 1 = Cliente General
          razon_social: this.clienteSeleccionado ? this.clienteSeleccionado.nombre : 'Cliente General',
          nit: this.nitCliente || '0',
          total_cancelar: this.totalAPagar,
          descuento_manual: parseFloat(this.descuentoManual) || 0,
          // Se elimina "descuento: 0" para que el backend aplique su cálculo automático en combos
          efectivo: efectivoVenta,
          productos: productosPayload,
          paquetes: paquetesPayload,
          caja_id: this.caja ? this.caja.id : 1,
          tipo_pago_id: 1, // 1 = CONTADO (Fijo para el POS)
          metodo_pago_id: pagoId, // 1 = Efectivo, 2 = Tarjeta, 6 = QR
          monto_pago: montoPagoVenta,
          dias_credito: 0,
          a_cuenta: 0,
          cambio: 0,
          facturado: 0,
          observacion: this.observacionVenta || 'Venta rápida desde POS',
          nombre_paquete: null,
          nro_tarjeta: null,
          proforma: false,
          interes_venta_credito: 0,
          monto_interes_venta_credito: 0,
          venta_credito: false,
          vehiculo_id: null,
          canal_venta_id: this.canalVenta, // AQUÍ GUARDAMOS EL CANAL DE VENTA SELECCIONADO
          fact_indicador: 0,
          proforma_id: null,
          sucursal_id: sucursalActiva,
          mostrar_fecha_venta: false,
          fecha_venta: null,
          venta_fecha_diferente: false
        };        
        const res = await this.posService.procesarVenta(payload);
        
        if (res.success || res.status === 200 || res.venta) {
          this.$toast.add({
            severity: 'success',
            summary: 'Venta Procesada',
            detail: res.message || 'El pedido se ha registrado exitosamente.',
            life: 4000
          });
          
          
          // === INICIO DE IMPRESIÓN DIRECTA DESDE BACKEND ===
          // Reseteo total del estado de caja limpio para el siguiente cliente
          this.carrito = [];
          this.canalVenta = 1;
          this.metodoPago = 1;
          this.observacionVenta = '';
          this.clienteSeleccionado = null;
          this.nitCliente = '';
          this.descuentoManual = null;
          //para poder actualizar el catalo y traer coreectamente el stock en el producto
          await this.cargarCatalogo();
          
          if (res.venta && res.venta.id) {
            try {
              const impresoConExito = await this.imprimirTicketVentaBackend(res.venta.id);
              
              if (impresoConExito) {
                // Imprimir copia extra idéntica para la cocina
                await this.imprimirTicketVentaBackend(res.venta.id);
              }
              
              if (!impresoConExito) {
                const pdfBlob = await this.ventaService.obtenerPdfVenta(res.venta.id);
                const url = URL.createObjectURL(pdfBlob);
                window.open(url, '_blank');
              }
            } catch (error) {
              this.$toast.add({ severity: 'error', summary: 'Error de impresión', detail: error.message || 'Error al imprimir ticket', life: 5000 });
            }
          }
          // === FIN IMPRESIÓN ===
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error al procesar', detail: res.message || 'Revisa los datos', life: 5000 });
        }
      } catch (err) {
        console.error("Error en procesarVenta:", err);
        const errorMsg = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'No se pudo completar la operación.';
        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 5000 });
      } finally {
        this.procesando = false;
        this.mostrarModalConfirmacion = false;
      }
    },
    // NUEVO: Limpiar polling al destruir
    beforeDestroy() {
      if (this._detenerPolling) {
        this._detenerPolling()
      }
    },

    iniciarPollingStock(){
      //crear un ref reactive para el carrito
      const carritoRef = computed(() => this.carrito)
      const sucursalRef = computed(() => this.sucursal_id)

      const { stockActualizado, detener, obtenerStock } = useStockPolling(
        carritoRef,
        sucursalRef,
        { interval: 5000, autoStart: true }
      )
      this.stockEnTiempoReal = stockActualizado
      this.obtenerStockTiempoReal = obtenerStock      
      // Guardar referencia para limpiar
      this._detenerPolling = detener
    },

    // NUEVO: Obtener stock en tiempo real para un producto
    obtenerStockProducto(productoId, es_paquete) {
      if (!this.obtenerStockTiempoReal) return null
      return this.obtenerStockTiempoReal(productoId, es_paquete)
    },
    
    // NUEVO: Función para convertir números a letras (equivalente a NumberFormatter::SPELLOUT)
    numeroALetras(numero) {
      const Unidades = ['CERO', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE', 'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE', 'VEINTE', 'VEINTIUNO', 'VEINTIDOS', 'VEINTITRES', 'VEINTICUATRO', 'VEINTICINCO', 'VEINTISEIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE'];
      const Decenas = ['CERO', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
      const Centenas = ['CERO', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

      function NumeroALetrasParcial(num) {
        if (num < 30) return Unidades[num];
        if (num < 100) return Decenas[Math.floor(num / 10)] + (num % 10 !== 0 ? ' Y ' + Unidades[num % 10] : '');
        if (num === 100) return 'CIEN';
        if (num < 1000) return Centenas[Math.floor(num / 100)] + (num % 100 !== 0 ? ' ' + NumeroALetrasParcial(num % 100) : '');
        if (num === 1000) return 'MIL';
        if (num < 2000) return 'MIL ' + (num % 1000 !== 0 ? NumeroALetrasParcial(num % 1000) : '');
        if (num < 1000000) return NumeroALetrasParcial(Math.floor(num / 1000)) + ' MIL' + (num % 1000 !== 0 ? ' ' + NumeroALetrasParcial(num % 1000) : '');
        if (num === 1000000) return 'UN MILLON';
        if (num < 2000000) return 'UN MILLON ' + (num % 1000000 !== 0 ? NumeroALetrasParcial(num % 1000000) : '');
        return NumeroALetrasParcial(Math.floor(num / 1000000)) + ' MILLONES' + (num % 1000000 !== 0 ? ' ' + NumeroALetrasParcial(num % 1000000) : '');
      }

      const entero = Math.floor(numero);
      const centavos = Math.round((numero - entero) * 100);
      const centavosStr = centavos.toString().padStart(2, '0');
      
      const letrasEntero = NumeroALetrasParcial(entero);
      return `${letrasEntero} ${centavosStr}/100 BOLIVIANOS`;
    }
  }
}
</script>

<style scoped>
/* ==========================================================================
   HOVERS Y ESTILOS DE INTERFAZ DEL ORQUESTADOR (ZAPI PALETA DE MARCA)
   ========================================================================== */
.zapi-bg {
  background-color: #fbf9f8;
  /* Crema institucional */
}

.zapi-text-red {
  color: #e32f3a;
  /* Rojo marca */
}

.zapi-text-gold {
  color: #c98a02;
  /* Dorado tipográfico para precios */
}

.zapi-bg-red {
  background-color: #e32f3a !important;
}

.zapi-bg-red:hover {
  background-color: #c2151d !important;
}

.zapi-bg-gold {
  background-color: #d97e0a !important;
  color: #ffffff !important;
}

.zapi-bg-gold:hover {
  background-color: #d97e0a !important;
}

.zapi-font {
  font-family: 'Impact', 'Arial Black', sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* ==========================================================================
   CONTROLES EXCLUSIVOS DE VIEWPORT VERTICAL (VH) - EVITA EL DESBORDE DEL TERMINAL
   ========================================================================== */

/* Altura fija de las filas del grid de comidas */
:deep(.item-card-height) {
  height: 24vh;
}

/* ==========================================================================
   SCROLLBAR INVISIBLE Y ESTABLE (EVITA SALTOS VISUALES)
   ========================================================================== */
/* 1. Ocultar físicamente el scroll cuando el mouse NO está adentro, pero RESERVAR el espacio */
.pos-grid-container,
.pos-cart-table-container {
  overflow-y: hidden !important;
  scrollbar-gutter: stable;
  /* Evita que las tarjetas salten cuando aparece la barra */
}

/* 2. Mostrar el scroll cuando el mouse ENTRA al contenedor */
.pos-grid-container:hover,
.pos-cart-table-container:hover {
  overflow-y: auto !important;
  overflow-y: overlay !important;
}

.subgrupo-wrapper {
  background: #FDECC8;
  border-radius: 10px;
  padding: 2px 12px;
  margin-top: 10px;
  margin-bottom: 5px;
}
.subgrupo-label {
  font-size: 13px;
  font-weight: bold;
  color: #B5760B;
  margin-bottom: 2px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 3. Darle color rojo corporativo a la barra en navegadores compatibles */
.pos-grid-container::-webkit-scrollbar,
.pos-cart-table-container::-webkit-scrollbar {
  width: 12px;
}

.pos-grid-container::-webkit-scrollbar-track,
.pos-cart-table-container::-webkit-scrollbar-track {
  background: transparent;
}

.pos-grid-container::-webkit-scrollbar-thumb,
.pos-cart-table-container::-webkit-scrollbar-thumb {
  background: #e32f3a;
  /* Rojo Zapi */
  border-radius: 10px;
}

/* ==========================================================================
   BREAKPOINT PERSONALIZADO PARA MONITORES GRANDES (1600px+)
   ========================================================================== */
@media screen and (min-width: 1400px) {
  .zapi-card-5 {
    flex: 0 0 auto !important;
    width: 20% !important;
  }
}
</style>